import { Injectable } from '@angular/core';
import { MulticastObserverFactoryService } from '../../../../core/services/multicast-observer-factory.service';
import { Product } from '../entities';
import { BookingPauseInterface } from '../../../../shared/interfaces/booking-pause-interface';
import { Observable } from 'rxjs';
import { CoreService } from '../../generated';

@Injectable({
  providedIn: 'root'
})
export class ProductService {
  private products$: Observable<{ paymentTypeChoiceAvailable: boolean; products: Product[] }>; // <- same pointer always
  private products: { paymentTypeChoiceAvailable: boolean; products: Product[] };

  constructor(
    private coreService: CoreService,
    private multicastFactoryService: MulticastObserverFactoryService
  ) {}

  getProducts(shopId: number): Observable<{ paymentTypeChoiceAvailable: boolean; products: Product[] }> {
    if (this.products$) {
      return this.products$;
    }
    this.products$ = this.multicastFactoryService.create((observer?) => {
      if (this.products) {
        observer.next(this.products);
        observer.complete();
      } else {
        this.coreService.apiCorePaymentProductsInformation(shopId).subscribe({
          next: data => {
            this.products = {
              paymentTypeChoiceAvailable: data.paymentTypeChoiceAvailable,
              products: data.products.flatMap(x => x.products).map(p => new Product(p))
            };
            this.sortProducts(this.products.products);
            observer.next(this.products);
            observer.complete();
          },
          error: err => {
            observer.error(err);
            observer.complete();
          }
        });
      }
    });
    return this.products$;
  }

  private sortProducts(products: Product[]) {
    products.sort((a, b) => {
      if (a.topSellerProduct && !b.topSellerProduct) {
        return -1;
      }
      if (!a.topSellerProduct && b.topSellerProduct) {
        return 1;
      }
      if (a.rank.quality < b.rank.quality) {
        return 1;
      } // lower is better
      if (a.rank.quality > b.rank.quality) {
        return -1;
      }
      if (a.rank.definition < b.rank.definition) {
        return -1;
      }
      if (a.rank.definition > b.rank.definition) {
        return 1;
      }
      return 0;
    });
  }

  filterProductsBy(products: Product[], ageCategoryId: number, productCategoryId?: number): Product[] {
    if (!products) return [];
    return products.filter(p => {
      if (productCategoryId && productCategoryId !== p.productCategoryId) {
        return false;
      }
      if (ageCategoryId !== p.ageCategoryId) {
        return false;
      }
      return true;
    });
  }

  updateHasStopProducts(pauses: BookingPauseInterface[]) {
    this.products.products.forEach(p => {
      p.hasStopProduct = pauses.some(pause => p.definitionId === +pause['product_definition_id']);
    });
  }
}
